/**
 * Open / Close hamburger menu.
 *
 * @returns {{init: init}}
 */
const HeaderNav = (() => {
  const DOM = {};

  const cacheDOM = () => {
    DOM.header = document.getElementsByClassName('header');

    DOM.hamburger = document.getElementsByClassName("header__row--navClick");
    DOM.menu = document.getElementsByClassName("header__row--nav");

    DOM.searchButton = document.getElementsByClassName("header__row--search-button");
    DOM.searchInput = document.getElementsByClassName("header__row--search");
  };

  const openMenu = () => {
    let button = DOM.hamburger[0];
    let container = DOM.menu[0];
    let header = DOM.header[0];
    let input = DOM.searchInput[0];
    let searchButton = DOM.searchButton[0];

    if (!button.classList.contains('open')) {

      if (input.classList.contains('active')) {
        searchButton.classList.remove('open');
        input.classList.remove('active');
        input.style.height = '0px';
      }

      button.classList.add('open');
      header.classList.add('open');
      container.classList.add('active');

      container.style.height = 'auto';
      let height = container.clientHeight + "px";

      container.style.height = '0px';

      setTimeout(() => {
        container.style.height = height;
      }, 0);

    } else {
      button.classList.remove('open');

      container.style.height = '0px';

      container.addEventListener('transitionend',  () => {
        container.classList.remove('active');
        header.classList.remove('open');
      }, {
        once: true
      });
    }
  };

  const openSearch = () => {
    let searchButton = DOM.searchButton[0];
    let input = DOM.searchInput[0];
    let header = DOM.header[0];

    let container = DOM.menu[0];
    let button = DOM.hamburger[0];

    if (!searchButton.classList.contains('open')) {

      if (container.classList.contains('active')) {
        container.classList.remove('active');
        container.style.height = '0px';
        button.classList.remove('open');
      }

      searchButton.classList.add('open');
      header.classList.add('open');
      input.classList.add('active');

      input.style.height = 'auto';
      let height = input.clientHeight + "px";

      input.style.height = '0px';

      setTimeout(() => {
        input.style.height = height;
      }, 0);

    } else {
      searchButton.classList.remove('open');
      input.style.height = '0px';

      input.addEventListener('transitionend',  () => {
        input.classList.remove('active');
        header.classList.remove('open');
      }, {
        once: true
      });
    }
  };

  const eventListeners = () => {
    DOM.hamburger[0].addEventListener('click', (e) => {
      e.stopPropagation();
      openMenu();
    });

    DOM.searchButton[0].addEventListener('click', (e) => {
      e.stopPropagation();
      openSearch();
    });
  };

  const init = () => {
    cacheDOM();
    eventListeners();
  };

  return {
    init
  };
})();

export default HeaderNav;
